
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { deepEquals } from '@util/copy';
import { RouterFrom } from '@router/Routes';
import { TripLog } from '@clients/myTrips';
import AppPage from '@components/new-styleguide/AppPage.vue';
import BasicSetupScreen from '@components/vehicle-setup/BasicSetupScreen.vue';
import SetupStep1 from '@components/vehicle-setup/steps/SetupStep1.vue';
import SetupStep2 from '@components/vehicle-setup/steps/SetupStep2.vue';
import SetupStep3 from '@components/vehicle-setup/steps/SetupStep3.vue';
import SetupStep4 from '@components/vehicle-setup/steps/SetupStep4.vue';
import SetupStep5 from '@components/vehicle-setup/steps/SetupStep5.vue';
import SetupStep6 from '@components/vehicle-setup/steps/SetupStep6.vue';

const TriplogModule = namespace('Triplog');
const RouterModule = namespace('Router');

@Component({
  name: 'VehicleSetup',
  components: {
    SetupStep6,
    SetupStep5,
    SetupStep4,
    SetupStep3,
    SetupStep2,
    SetupStep1,
    BasicSetupScreen,
    AppPage
  }
})
export default class VehicleSetup extends Vue {
  @TriplogModule.Getter('getVehicles')
  private triplogs: TripLog[];

  @TriplogModule.Action('fetchVehicles')
  private fetchVehicles;

  @TriplogModule.Action('updateVehicleSetup')
  private updateVehicleSetup;

  @TriplogModule.Action('selectTriplog')
  private selectTriplog;

  @RouterModule.State('from')
  private from: RouterFrom;

  private requestError: string = null;

  async created() {
    if (!this.from.name) {
      await this.fetchVehicles();

      if (this.triplogs) {
        const setupVehicle = this.triplogs.find(t => t.vehicle.setupDone === false && t.vehicle.id === this.id);
        if (!setupVehicle) {
          this.exit()
        }
      }
    }

    this.selectTriplog({ triplog: this.triplog });
  }

  get triplog() {
    return this.triplogs.find(t => t.vehicle.id === this.id);
  }

  get id() {
    return parseInt(this.$route.params.id);
  }

  get step() {
    if (!this.$route.query.step) {
      return 0;
    }
    return parseInt(this.$route.query.step as string);
  }

  get returnTo() {
    return this.$route.query.from as string || 'myTrips';
  }

  private nextStep() {
    const query = {
      from: this.returnTo,
      vehicle: this.triplog.vehicle.id.toString(),
      step: String(this.step + 1)
    };

    if (!deepEquals(query, this.$route.query)) {
      this.$router.push({ query });
    }
  }

  private async next() {
    if (this.step < 5) {
      this.nextStep();
    } else {
      try {
        await this.updateVehicleSetup({ vehicleId: this.id })
        this.exit()
      } catch (e) {
        this.requestError = 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.';
      }
    }
  }

  private exit() {
    this.$router.replace({ name: this.returnTo, query: { vehicle: this.triplog.vehicle.id.toString() } });
  }
}
